import { render, staticRenderFns } from "./partnerComponent.vue?vue&type=template&id=e4825a76&scoped=true&"
import script from "./partnerComponent.vue?vue&type=script&lang=js&"
export * from "./partnerComponent.vue?vue&type=script&lang=js&"
import style0 from "./partnerComponent.vue?vue&type=style&index=0&id=e4825a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4825a76",
  null
  
)

export default component.exports